import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from "../_services/apis/authentication.service";
import { ZenDialogMsgService } from "../_services/helpers/zen-dialog-msg.service";
import {NavigationService} from "../_services/helpers/navigation.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private zenDialogMsgSvc: ZenDialogMsgService,
        private navSvc: NavigationService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {

        this.authService.redirectUrl = state.url;
        const token = route.queryParams['token'];

        if (token) {
            // Wait for the loginWithToken observable to resolve
            return new Observable<boolean>(observer => {
                this.authService.loginWithToken(token).subscribe({
                    next: res => {
                        if (res.token) {
                            // The redirectUrl looks like - /deal-desk/contract/812e476a-88a8-4bff-96ed-42e630691879?token=eyJhb...
                            // Using split('?')?.[0] we able to get the url segment without the params (?token).
                            const _tokenRemovedUrl = this.authService.redirectUrl?.split('?')?.[0];
                            this.router.navigateByUrl(_tokenRemovedUrl);
                            observer.next(true); // Signal successful activation
                            observer.complete();
                        } else {
                            console.log('Failed to log in with token');
                            this.navSvc.navigate(['/']);
                            this.zenDialogMsgSvc.openToast(false, 'Sorry! The link you followed has expired.');
                            observer.next(false); // Signal unsuccessful activation
                            observer.complete();
                        }
                    },
                    error: err => {
                        console.error('Login error:', err);
                        this.navSvc.navigate(['/']);
                        this.zenDialogMsgSvc.openToast(false, 'An error occurred during login.');
                        observer.next(false); // Signal unsuccessful activation
                        observer.complete();
                    }
                });
            });
        } else if (this.authService.getCurrentUser?.token) {
            // User is already logged in
            return true;
        }

        // If no token or user, redirect to login
        this.authService.logout();
        this.navSvc.navigate(['/']);
        return false;
    }
}
